// extracted by mini-css-extract-plugin
module.exports = {"center":"FaqCollapse_center__2KnEk"};